<script setup>
import { onMounted } from 'vue';
import { useAppStore } from '@/store/app';
import CustomerSubscriptionsTable from '../components/CustomerSubscriptionsTable.vue';

const store = useAppStore();

onMounted(() => {
  store.fetchAllUsers();
});

// const onOpenCustomerTransaction = ({ customer }) => {
//   if (customer?.subscriptionId === 0 && customer?.subscriptionStartDate === DEFAULT_DATE) return;
//   router.push(`/all-customer-list/${customer?.id}`);
// };
</script>

<script>
// normal `<script>`, executed in module scope (only once)
// declare additional options
export default {
  inheritAttrs: false,
  customOptions: {},
};
</script>

<template inheritAttrs="false">
  <div class="customer-subscriptions">
    <CustomerSubscriptionsTable :subscriptions="store.customerSubscriptions" />
  </div>
</template>

<style scoped lang="scss">
.customer-subscriptions {
  margin-top: 15px;
}
</style>
